import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Text, Box } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { IconTrash } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { canAccessModifyModulQC } from "../../utils/accessing";

import ModalResponse from "../general/ModalResponse";
import ModalTakeAction from "../general/ModalTakeAction";
import InputWrapperCustom from "../general/InputWrapperCustom";

import MediaImageVideoDropper from "./MediaImageVideoDropper";
import videoThumbnail from "../../assets/images/video-thumbnail-1.png";

const CarouselContainer = ({ children, stateData, stateHeightImage }) => {
  return (
    <Carousel
      withIndicators={false}
      withControls={Array.isArray(stateData) && (stateData.length > 1)}
      height={stateHeightImage}
      slideSize="33.333333%"
      slideGap="xs"
      loop
      align="start"
      mt='sm'
    >
      {children}
    </Carousel>
  )
}

const BoxDel = ({ fnOnClick, stateIndex }) => {
  return (
    <Box
      px='.5rem'
      sx={(tema) => ({
        height: '30px',
        backgroundColor: tema.fn.rgba('#404040', 0.75),
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer'
      })}

      onClick={fnOnClick}
    >
      <Text color="#fff">
        {String(Number(stateIndex) + 1)}
      </Text>
      <IconTrash size={18} color='#fff' />
    </Box>
  )
}

const BoxUtils = ({ stateIndex }) => {
  return (
    <Box
      sx={(tema) => ({
        height: '30px',
        backgroundColor: tema.fn.rgba('#404040', 0.75),
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      })}
    >
      <Text color="#fff">
        {String(Number(stateIndex) + 1)}
      </Text>
    </Box>
  )
}

const MediaImageVideoCarousel = ({ stateData, fnOnChange, fnClickMedia, stateMT }) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const heightImage = 150;

  const notificationId = React.useRef({
    errorDeleteData: 'MediaImageVideoCarousel-1',
  })

  const [data, setData] = React.useState({
    deleteModal: false,
    deleteId: '',
    deleteName: '',
    deleteLoading: false,

    dataImages: [],
    dataVideos: [],

    camModalShow: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    const dt = stateData.data.value;

    if (Array.isArray(dt) && (dt.length > 0) && dt.some(key => key.file_type === utils.mediaQCType.image.value)) {
      setData(d => ({ ...d, dataImages: dt.filter(keyImgMedia => keyImgMedia.file_type === utils.mediaQCType.image.value) }))
    } else {
      setData(d => ({ ...d, dataImages: [] }))
    }

    if (Array.isArray(dt) && (dt.length > 0) && dt.some(key => key.file_type === utils.mediaQCType.video.value)) {
      setData(d => ({ ...d, dataVideos: dt.filter(keyVidMedia => keyVidMedia.file_type === utils.mediaQCType.video.value) }))
    } else {
      setData(d => ({ ...d, dataVideos: [] }))
    }
  }, [stateData.data.value])

  const deleteData = () => {
    setData(d => ({ ...d, deleteLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', stateData.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);
    formDT.append('media_id', data.deleteId);
    formDT.append('media_name', data.deleteName);

    axios({
      method: 'post',
      url: BE_API_THREE + '/delete_media_qc',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, deleteLoading: false, deleteModal: false }));

      if (response.data.flag_status === 'isset') {
        fnOnChange(response.data.data);
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorDeleteData,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        deleteLoading: false,
        deleteModal: false
      }))

      notifications.show({
        id: notificationId.current.errorDeleteData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const canModify = utils.projectProcess.qc.value;

  return (
    <React.Fragment>
      <InputWrapperCustom
        stateLabelFullWidth={true}
        stateLabel={
          <Group position='apart' mb='.75rem'>
            <Group spacing={6}>
              <Text>{stateData.data.label}</Text>
              <Text>({Array.isArray(stateData.data.value) ? stateData.data.value.length : 0})</Text>
            </Group>
          </Group>
        }
        stateWithAsterisk={stateData.data.withAsterisk}
        stateError={stateData.data.error}
        stateDescription={stateData.data.description}
        stateMT={stateMT}
      >
        {(((Array.isArray(data.dataImages) && (data.dataImages.length <= 0)) || !data.dataImages) && ((Array.isArray(data.dataVideos) && (data.dataVideos.length <= 0)) || !data.dataVideos)) &&
          <Text size='sm' mt='-0.5rem' color="dimmed">Tidak ada foto dan video QC</Text>
        }

        {Array.isArray(data.dataImages) && (data.dataImages.length > 0) &&
          <CarouselContainer
            stateData={data.dataImages}
            stateHeightImage={heightImage}
          >
            {Object.keys(data.dataImages).map((keyFB, index) => {
              return (
                <Carousel.Slide key={keyFB}>
                  <Box sx={{ position: 'relative', height: heightImage + 'px' }}>
                    <img
                      alt={`media-qc-img-${index}`}
                      src={ROOT_BASE_URL + data.dataImages[keyFB].file_name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}

                      onClick={() => {
                        fnClickMedia({
                          images: data.dataImages,
                          title: 'Media Hasil QC',
                          index: keyFB,
                          fieldName: 'file_name',
                          type: data.dataImages[keyFB].file_type,
                        })
                      }}
                    />

                    {((canModify === stateData.projectProcess) && (canAccessModifyModulQC({ stateObject: { subLevel: loginContext } }))) ?
                      <BoxDel
                        stateIndex={keyFB}
                        fnOnClick={() => setData(d => ({
                          ...d,
                          deleteId: data.dataImages[keyFB].qc_media_id,
                          deleteName: data.dataImages[keyFB].file_name,
                          deleteModal: true
                        }))}
                      />
                      :
                      <BoxUtils
                        stateIndex={keyFB}
                      />
                    }
                  </Box>
                </Carousel.Slide>
              )
            })}
          </CarouselContainer>
        }

        {Array.isArray(data.dataVideos) && (data.dataVideos.length > 0) &&
          <CarouselContainer
            stateData={data.dataVideos}
            stateHeightImage={heightImage}
          >
            {Object.keys(data.dataVideos).map((keyFB, index) => {
              return (
                <Carousel.Slide key={keyFB}>
                  <Box sx={{ position: 'relative', height: heightImage + 'px' }}>
                    <img
                      alt={`media-qc-vid-${index}`}
                      src={videoThumbnail}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}

                      onClick={() => {
                        fnClickMedia({
                          name: `${ROOT_BASE_URL}${data.dataVideos[keyFB].file_name}`,
                          title: 'Media Hasil QC',
                          type: data.dataVideos[keyFB].file_type,
                        })
                      }}
                    />

                    {((canModify === stateData.projectProcess) && (canAccessModifyModulQC({ stateObject: { subLevel: loginContext } }))) &&
                      <BoxDel
                        stateIndex={keyFB}
                        fnOnClick={() => setData(d => ({
                          ...d,
                          deleteId: data.dataVideos[keyFB].qc_media_id,
                          deleteName: data.dataVideos[keyFB].file_name,
                          deleteModal: true
                        }))}
                      />
                    }
                  </Box>
                </Carousel.Slide>
              )
            })}
          </CarouselContainer>
        }

        {((canModify === stateData.projectProcess) && (canAccessModifyModulQC({ stateObject: { subLevel: loginContext } }))) &&
          <MediaImageVideoDropper
            stateData={{
              projectId: stateData.projectId,
              projectProcess: stateData.projectProcess,
              projectIsCancel: stateData.projectIsCancel,
              userAccess: stateData.userAccess,
            }}

            fnOnAdded={(dataArray) => {
              fnOnChange(dataArray);
            }}
          />
        }
      </InputWrapperCustom>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.deleteModal}
        fnHide={() => setData(d => ({ ...d, deleteModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Hapus'
        stateButtonActionPx='xs'
        stateButtonActionColor="red"
        stateButtonActionLoading={data.deleteLoading}
        fnButtonAction={deleteData}
      >
        <Text size='sm'>
          Hapus media ini ?
        </Text>
      </ModalTakeAction>
    </React.Fragment>
  )
}

export default MediaImageVideoCarousel;